// 做一些全局配置，以及拦截器的配置
import axios from 'axios'
// 1. 引入公共配置文件（核心：从配置中读取路径，而非硬编码）
import config from '@/config' 

// 实例化axios对象
const instance = axios.create({
  baseURL: config.baseApiUrl,
  timeout: config.requestTimeout
})
// 添加请求拦截器,config接受参数的方式，随意命名
instance.interceptors.request.use(
  config => {
    // 如果不是FormData类型，才设置默认Content-Type
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json;charset=utf-8'
    }
    return config
  },
  error => {
    // 处理错误请求
    return Promise.reject(error)
  }
)
// 添加响应拦截器
instance.interceptors.response.use(
  res => {
    // 响应接收后做的事情，在then catch finally之前做的事情
    if (res.status !== 200) {
      alert('数据请求失败')
    }
    return res
  },
  error => {
    // 非200状态码走这里
    return Promise.reject(error)
  }
)
// 暴露新的axios实例
export default instance
